module.exports = __webpack_public_path__ + "img/star.ae27ff8.svg";